export type EventName =
  | 'quiz_start'
  | 'quiz_question'
  | 'quiz_gate_start'
  | 'quiz_gate_input'
  | 'quiz_submit'
  | 'quiz_gate_skip'
  | 'quiz_answer_skip'
  | 'variants_error';

export function pushEvent<T extends object>(event: EventName, params: T): void {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (e) {
    console.error('[analytics] pushEvent failed', e);
  }
}
